import { render, staticRenderFns } from "./RenameRole.vue?vue&type=template&id=720b2640&scoped=true"
import script from "./RenameRole.vue?vue&type=script&lang=js"
export * from "./RenameRole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "720b2640",
  null
  
)

export default component.exports